import { FIVE_MINUTES_IN_MILLISECONDS } from '@/constants/numberVars';
import queryKeys from '@/constants/queryKeys';
import { getUnreadNotificationsCount } from '@/services/api/requests/notifications';
import { useQuery } from '@tanstack/react-query';
import { useAppStore } from '@/store/useAppStore';

const useGetUnreadNotificationsCount = () => {
  const isAuthenticated = useAppStore((state) => !!state.user);

  const { isLoading, data, isError, error, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.notifications.unreadCount],
    // Polled queries must stop when there is no session. Otherwise the interval
    // can fire during sign-out teardown, 401, and walk the whole refresh path for
    // a user who is already on their way out.
    enabled: isAuthenticated,
    refetchInterval: FIVE_MINUTES_IN_MILLISECONDS,
    queryFn: async () => {
      const response = await getUnreadNotificationsCount();

      return response;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch };
};

export default useGetUnreadNotificationsCount;
